import React from 'react';
import { useArchReAppContext } from '@archre2/react-core';
import { Icon, Modal, ModalContent, ModalHeader } from '@archre2/react-core';

const onClose = (navigate) => navigate('/');

const Page401 = () => {
  const { navigate } = useArchReAppContext();
  return (
    <Modal onClose={() => onClose(navigate)} className="radius-xs">
      <ModalHeader onClose={() => onClose(navigate)}>
        401 - Unauthorized
      </ModalHeader>
      <ModalContent className="flex-column items-center padding-lg">
        <h2 className="text-semi text-center margin-b-md">
          You are not authorized to view this page....
        </h2>
        <Icon className="text-large">eye-slash</Icon>
      </ModalContent>
    </Modal>
  );
};

export default Page401;
